import {
  WebTracerProvider,
  BatchSpanProcessor,
  SimpleSpanProcessor,
} from '@opentelemetry/sdk-trace-web';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { B3Propagator } from '@opentelemetry/propagator-b3';
import { defaultResource, resourceFromAttributes } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { environment } from '@env/environment';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';

export function initTracing(): void {
  const collectorUrl = environment.otelCollectorUrl;
  if (!collectorUrl) {
    return;
  }

  const spanProcessors = [
    new SimpleSpanProcessor(
      new OTLPTraceExporter({
        url: collectorUrl,
        headers: {
          'Content-Type': 'application/json',
        },
      })
    ),
  ];

  const provider = new WebTracerProvider({
    resource: defaultResource().merge(
      resourceFromAttributes({
        [ATTR_SERVICE_NAME]: 'mf-unibox',
      })
    ),
    spanProcessors,
  });

  provider.register({
    contextManager: new ZoneContextManager()
  });

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation(),
      new XMLHttpRequestInstrumentation(),
      new DocumentLoadInstrumentation(),
    ],
  });
}